import { RestartAlt } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface ResetRemoteStateButtonProps {
  onRemoteStateReset?: () => void;
}

export const ResetRemoteStateButton = ({ onRemoteStateReset }: ResetRemoteStateButtonProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'DataGrid.resetRemoteStateButton' });
  return (
    <Tooltip title={t('tooltip')} arrow>
      <IconButton
        size="small"
        color="inherit"
        onClick={() => {
          if (onRemoteStateReset) {
            onRemoteStateReset();
          }
        }}
      >
        <RestartAlt fontSize="small" color="inherit" />
      </IconButton>
    </Tooltip>
  );
};
